import {definePreset} from '@primeuix/themes';
import Lara from '@primeuix/themes/lara';

export const PrimengCustomLaraPreset = definePreset(Lara, {
  primitive: {
    borderRadius: {
      none: '0',
      xs: '3px',
      sm: '3px',
      md: '3px',
      lg: '3px',
      xl: '3px'
    }
  },
  semantic: {
    primary: {
      50: 'var(--mdc-blue-50)',
      100: 'var(--mdc-blue-100)',
      200: 'var(--mdc-blue-200)',
      300: 'var(--mdc-blue-300)',
      400: 'var(--mdc-blue-400)',
      500: 'var(--mdc-blue-500)',
      600: 'var(--mdc-blue-600)',
      700: 'var(--mdc-blue-700)',
      800: 'var(--mdc-blue-800)',
      900: 'var(--mdc-blue-900)'
    },
    colorScheme: {
      light: {
        highlight: {
          background: '{primary.50}',
          focusBackground: '{primary.100}',
          color: '{text.color}',
          focusColor: '{text.hover.color}'
        },
        formField: {
          disabledBackground: '{surface.0}',
          disabledColor: 'color-mix(in srgb, {form.field.color}, transparent 40%)',
          hoverBorderColor: '{primary.500}',
          focusBorderColor: '{primary.500}'
        }
      },
      dark: {
        formField: {
          hoverBorderColor: '{primary.color}',
          focusBorderColor: '{primary.color}'
        }
      }
    },
    formField: {
      borderRadius: '3px'
    },
    content: {
      borderRadius: '3px'
    },
    list: {
      option: {
        borderRadius: '3px'
      }
    },
    navigation: {
      item: {
        borderRadius: '3px'
      }
    },
    overlay: {
      select: {
        borderRadius: '3px'
      },
      popover: {
        borderRadius: '3px'
      },
      modal: {
        borderRadius: '3px'
      }
    }
  },
  components: {
    button: {
      root: {
        borderRadius: '3px'
      },
      css: `
        body .p-button.p-button-primary {
          background: var(--primary);
          border-color: var(--primary);
          color: var(--primary-text);
        }
        body .p-button.p-button-primary:not(:disabled):hover {
          background: color-mix(in srgb, var(--primary), black 8%);
          border-color: color-mix(in srgb, var(--primary), black 8%);
          color: var(--primary-text);
        }
        body .p-button.p-button-primary:not(:disabled):active {
          background: color-mix(in srgb, var(--primary), black 12%);
          border-color: color-mix(in srgb, var(--primary), black 12%);
          color: var(--primary-text);
        }
        .p-button.p-button-sm .p-button-icon {
          font-size: .875rem
        }
        .p-button.p-button-lg .p-button-icon {
          font-size: 1.25rem
        }
      `
    },
    card: {
      root: {
        borderRadius: '3px'
      },
      body: {
        padding: '1rem'
      }
    },
    drawer: {
      header: {
        padding: '1rem'
      },
      content: {
        padding: '1rem'
      },
      footer: {
        padding: '1rem'
      }
    },
    datatable: {
      columnTitle: {
        fontWeight: '500'
      },
      colorScheme: {
        light: {
          header: {
            background: 'var(--bs-gray-100)'
          },
          headerCell: {
            background: 'var(--bs-gray-100)',
            selectedBackground: '{highlight.background}'
          }
        }
      }
    },
    inputtext: {
      root: {
        borderRadius: '3px'
      },
      css: `
        .p-inputtext:disabled {
          border-color: color-mix(in srgb, var(--p-form-field-border-color), transparent 40%);
        }
      `
    },
    panel: {
      colorScheme: {
        light: {
          header: {
            background: 'var(--bs-gray-100)'
          }
        }
      },
      header: {
        padding: '1rem'
      }
    },
    paginator: {
      navButton: {
        selectedBackground: '{highlight.background}',
        selectedColor: '{highlight.color}'
      }
    },
    select: {
      root: {
        paddingX: '0.5rem',
        paddingY: '0.5rem'
      }
    },
    steps: {
      itemNumber: {
        activeBackground: '{primary.50}',
        activeColor: 'var(--bs-gray-700)',
        activeBorderColor: '{primary.50}'
      },
      itemLabel: {
        activeColor: 'var(--bs-gray-700)'
      }
    }
  }
});
